import { createFileRoute } from "@tanstack/react-router";
import { Button, Card } from "@magarac/ui";
import { API_BASE } from "../lib/auth-client";

export const Route = createFileRoute("/calendar-connect/test")({
  validateSearch: (s: Record<string, unknown>): { provider: string; state: string } => ({
    provider: typeof s.provider === "string" ? s.provider : "google",
    state: typeof s.state === "string" ? s.state : "",
  }),
  component: TestCalendarSignIn,
});

/**
 * Stands in for Google's and Microsoft's sign-in pages until those apps exist (never available
 * in production). "Allow" completes the same callback a real sign-in would, with a test
 * calendar behind it.
 */
function TestCalendarSignIn() {
  const { provider, state } = Route.useSearch();
  const name = provider === "microsoft" ? "Outlook" : "Google Calendar";
  const go = (allow: boolean) => {
    const q = `state=${encodeURIComponent(state)}${allow ? "&code=test" : "&error=access_denied"}`;
    window.location.assign(`${API_BASE}/v1/calendar-links/callback/fake?${q}`);
  };
  return (
    <main className="mx-auto max-w-md p-6">
      <Card title={`Connect ${name} (test)`}>
        <p className="mb-2">
          This is a test sign-in. The real {name} sign-in page appears here once J360's calendar
          connection is approved.
        </p>
        <p className="mb-4 text-sm text-muted">
          Allowing connects a test calendar: J360 visits are placed on it and busy time is read from
          it, so you can try everything out.
        </p>
        <div className="flex gap-2">
          <Button onClick={() => go(true)} disabled={!state}>
            Allow
          </Button>
          <Button variant="secondary" onClick={() => go(false)} disabled={!state}>
            Cancel
          </Button>
        </div>
      </Card>
    </main>
  );
}
